import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { PMSnames } from 'main/hotelBrandsAndChains'
import moment from 'moment'
import CreatableSelect from 'react-select/creatable'
import { useToasts } from 'react-toast-notifications'

import { checkDate, handleChangeReferrer } from '../../helpers'
import styles from '../../NewHotel.module.scss'

const HotelInfoSection = ({
  formData,
  handleFormChange,
  setFormData,
  salesAgents,
  csmUsers,
  referrers,
  parentChainNames,
  chains,
  chainName,
  handleParentChange,
  setChainName
}) => {
  const { addToast } = useToasts()

  const {
    salesPersonUserId,
    csmId,
    parentChainCode,
    pms,
    numberOfRooms,
    serviceStartDate,
    supportEmail,
    supportPhone
  } = formData

  return (
    <>
      <h4 className={styles.sectionTitle}>Hotel Information</h4>
      <div className={styles.formRow}>
        <Dropdown
          label="Sales agent"
          defaultVal={'Select sales agent'}
          options={salesAgents?.reduce(
            (acc, curr) => ({ ...acc, [curr.id]: curr.fullName }),
            {}
          )}
          onChange={handleFormChange}
          name="salesPersonUserId"
          value={salesPersonUserId}
        />
        <Dropdown
          label="Customer success manager"
          defaultVal={'Select CSM'}
          options={csmUsers?.reduce(
            (acc, curr) => ({ ...acc, [curr.id]: curr.fullName }),
            {}
          )}
          onChange={handleFormChange}
          name="csmId"
          value={csmId}
        />
        <div className={styles.creatableSelectContainer}>
          <div className={styles.label}>Select Referrer</div>
          <CreatableSelect
            onChange={(newValue, actionMeta) => {
              handleChangeReferrer(newValue, actionMeta, setFormData)
            }}
            options={referrers}
            styles={{
              option: base => ({
                ...base,
                fontSize: '13px',
                color: '#000'
              })
            }}
          />
        </div>
      </div>
      <div className={styles.formRow}>
        <Dropdown
          options={parentChainNames}
          label="Brand"
          defaultVal="Select parent"
          value={parentChainCode}
          name="parentChainCode"
          onChange={handleParentChange}
        />
        {parentChainCode !== 'independent' && (
          <Dropdown
            label="Chain"
            disabled={!parentChainCode}
            defaultVal={parentChainCode ? 'Select chain' : 'Select parent first'}
            options={chains}
            name="chainCode"
            value={chainName}
            onChange={e => setChainName(e.target.value)}
          />
        )}
        <Dropdown
          options={PMSnames}
          label="PMS"
          defaultVal="Select PMS"
          name="pms"
          onChange={handleFormChange}
          value={pms}
        />
      </div>
      <div className={styles.formRow}>
        <TextInput
          type="text"
          label="Number of rooms"
          className={styles.input}
          name="numberOfRooms"
          value={numberOfRooms}
          onChange={handleFormChange}
        />
        <TextInput
          type="date"
          label="Service start date"
          className={styles.input}
          min={moment().add(1, 'days').format('YYYY-MM-DD')}
          name="serviceStartDate"
          value={serviceStartDate}
          onChange={e => checkDate(e.target.value, addToast, setFormData)}
        />
      </div>
      <div className={styles.formRow}>
        <TextInput
          label="Support email"
          name="supportEmail"
          value={supportEmail}
          onChange={handleFormChange}
        />
        <TextInput
          label="Support phone"
          name="supportPhone"
          value={supportPhone}
          onChange={handleFormChange}
        />
      </div>
    </>
  )
}

export default HotelInfoSection
